// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7b3e13ea","732":"c6d960a3","977":"23f45280"}[chunkId] + ".chunk.js";
};